export const getFullTrackerName = (
  trackerName: string | undefined,
  version: string | undefined
) => {
  if (!trackerName || !version) return 'facelift'

  return `${trackerName}_${version}`
}
